import React from 'react'
import { Group } from '../group'
import { QuestionDefinition } from 'components/questionnaire/questions.yml'

interface Props {
  groups: { [key: string]: string }
  questions: QuestionDefinition[]
}

export function Survey({groups, questions}: Props) {
const totalQuestions = questions.length

  return (
    <>
      {Object.entries(groups).map(([shortCode, title]) => {
        const groupQuestions = questions.filter(
          value => value.group === shortCode
        )
        return (
          <Group key={shortCode} questions={groupQuestions} total={totalQuestions} title={title} />
        )
      })}
    </>
  )
}
